import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../models/backofficeConfiguration';
import { ExecuteService } from './executeService.service';
import { ErrorHandlerService } from './errorHandler.service';
import { EventDateFilter } from '../models/eventDateFilter';
import { CalendarEventBO } from '../models/calendarEventDateBO';
import { EventFilter } from '../models/eventFilter';

@Injectable()
export class CalendarBOService {

  constructor(private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public FindEvent(eventFilter: EventFilter): Observable<CalendarEventBO[]> {
    const requestUrl = `${APP_SETTINGS.CalendarApiUrl}api/EventFilter/Find`;
    const body: any = JSON.stringify(eventFilter);
    return this.executeService.ExecuteWithToken('post', requestUrl, null, body)
      .pipe(
        catchError((error: any): any => {
          let ignoreNotFound = false;
          if (error.status === 404) {
            ignoreNotFound = true;
          }
          return this.errorHandler.handleError<object[]>('CalendarService_EventDateFilter_Find', null, ignoreNotFound);
        }));
  }

  public FindEventDate(eventDateFilter: EventDateFilter): Observable<CalendarEventBO[]> {
    const requestUrl = `${APP_SETTINGS.CalendarApiUrl}api/EventDateFilter/Find`;
    const body: any = JSON.stringify(eventDateFilter);
    return this.executeService.ExecuteWithToken('post', requestUrl, null, body)
      .pipe(
        catchError((error: any): any => {
          let ignoreNotFound = false;
          if (error.status === 404) {
            ignoreNotFound = true;
          }
          return this.errorHandler.handleError<object[]>('CalendarService_EventDateFilter_Find', null, ignoreNotFound);
        }));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/calendarBO.service.ts